export var MAP = {

  // English

  'en': {
    'LANGUAGE': 'Language',
    'LOCALE_en': 'English',
    'LOCALE_es': 'Spanish',
    'USERNAME': 'Username',
    'PASSWORD': 'Password',
    'LOGIN': 'Login',
    'LOGOUT': 'Logout',
    'OK': 'Ok',
    'ACCEPT': 'Accept',
    'CANCEL': 'Cancel',
    'YES': 'Yes',
    'NO': 'No',
    'RESET': 'Reset',
    'CONFIRM': 'Confirm',
    'NEXT': 'Next',
    'PREVIOUS': 'Previous',
    'FINISH': 'Finish',
    'SAVE': 'Save',
    'REFRESH': 'Refresh',
    'SEARCH': 'Search',
    'FILTER': 'Filter',
    'DELETE': 'Delete',
    'ADD': 'New',
    'SELECT': 'Select',
    'SELECT_ALL': 'Select all',
    'INFO': 'Information',
    'ERROR': 'Error',
    'FOUND': 'Found',
    'RESULTS': 'Results',
    'TOTAL': 'Total',
    'MONEY': 'Money',
    'HOME': 'Home',
    'SHOW_CONSOLE': 'Show console',
    'FILE': 'File',
    'OPTIONS': 'Options',
    'EDIT': 'Edit',
    'UNDO': 'Undo',
    'REDO': 'Redo',
    'COPY': 'Copy',
    'PASTE': 'Paste',
    'LOCK': 'Lock',
    'EXIT': 'Exit',
    'SETTINGS': 'Settings',
    'FORM': 'Form',
    'LIST': 'List',
    'TABLE': 'Table',
    'DETAIL': 'Detail',
    'EXPORT': 'Export',
    'EXPORT_PDF': 'Export to PDF',
    'EXPORT_CSV': 'Export to CSV',
    'PAGE': 'Page',
    'FIRST_PAGE': 'First',
    'LAST_PAGE': 'Last',
    'PREVIOUS_PAGE': 'Previous',
    'NEXT_PAGE': 'Next',
    'PHOTO': 'Picture',
    'CHOOSE_FILE': 'Choose file',

    'FORM_VALIDATION.REQUIRED': 'Required',
    'FORM_VALIDATION.LENGTH': 'Invalid length',
    'FORM_VALIDATION.MIN_LENGTH': 'Minimum length',
    'FORM_VALIDATION.MAX_LENGTH': 'Maximum length',
    'FORM_VALIDATION.FORMAT': 'Invalid format',
    'FORM_VALIDATION.EMAIL_FORMAT': 'Invalid email',
    'FORM_VALIDATION.NIF_FORMAT': 'Invalid format (DNI: 12345678-A, NIE: X-1234567-A)',
    'FORM_VALIDATION.DNI_LETTER': 'Invalid DNI letter',
    'FORM_VALIDATION.DATE_RANGE': 'Date outside valid range',
    'FORM_VALIDATION.MIN_VALUE': 'Minimum value',
    'FORM_VALIDATION.MAX_VALUE': 'Maximum value',

    'FORM_VALIDATION.DATE_PARSE':'Date not valid format',
    'FORM_VALIDATION.DATE_FILTER':'Date is not valid for the defined filter',
    'FORM_VALIDATION.DATE_MIN':'Date min',
    'FORM_VALIDATION.DATE_MAX':'Date max',


    'MESSAGES.FORM_VALIDATION_ERROR': 'Form values are not valid!',
    'MESSAGES.FORM_NOTHING_TO_UPDATE_INFO': 'There are no values to update!',
    'MESSAGES.ERROR_LOGIN': 'Login failed. Check username and/or password.',
    'MESSAGES.ERROR_SESSION': 'Session expired.',
    'MESSAGES.ERROR_INSERT': 'Failed to insert data.',
    'MESSAGES.ERROR_QUERY': 'Failed to get data from the server.',
    'MESSAGES.ERROR_UPDATE': 'Failed to save data.',
    'MESSAGES.ERROR_DELETE': 'Failed to delete data.',
    'MESSAGES.ERROR_ATTRIBUTE_REQUIRED': 'Required attribute not set.',
    'MESSAGES.ERROR_FILE_LOAD': 'Failed to load file.',
    'MESSAGES.CONFIRM_LOGOUT': 'Are you sure you want to leave?',
    'MESSAGES.CONFIRM_DELETE': 'Are you sure you want to delete the selected items?',
    'MESSAGES.CONFIRM_CANCEL': 'Are you sure you want to cancel without saving changes?',
    'MESSAGES.SAVING': 'Saving, please wait...',
    'MESSAGES.SAVED': 'Saved',
    'MESSAGES.NO_RESULTS': 'No results were obtained.',
    'MESSAGES.ERROR_MISSING_LANG': 'Selected language bundle file not found',

    'TABLE.EMPTY': 'No results found',
    'TABLE.INFO': '_START_ - _END_ of _TOTAL_',
    'TABLE.INFO_EMPTY': '0 - 0 of 0',
    'TABLE.INFO_FILTERED': '(filtered from _MAX_ total entries)',
    'TABLE.INFO_POST_FIX': ' ',
    'TABLE.LENGTH_MENU': 'Rows per page: _MENU_',
    'TABLE.LOADING_RECORDS': 'Loading...',
    'TABLE.PROCESSING': 'Processing...',
    'TABLE.SEARCH': ' ',
    'TABLE.ZERO_RECORDS': 'No matching records found',
    'TABLE.PAGINATE.FIRST': 'First',
    'TABLE.PAGINATE.LAST': 'Last',
    'TABLE.PAGINATE.NEXT': 'Next',
    'TABLE.PAGINATE.PREVIOUS': 'Previous',
    'TABLE.ARIA.SORT_ASCENDING': ': activate to sort column ascending',
    'TABLE.ARIA.SORT_DESCENDING': ': activate to sort column descending',
    'TABLE.BUTTONS.COLVIS': 'Show / hide columns',
    'TABLE.BUTTONS.COPY_TITLE': 'Added to clipboard',
    'TABLE.BUTTONS.COPY_SUCCESS._': '%d rows copied',
    'TABLE.BUTTONS.COPY_SUCCESS.1': '1 row copied',
    'TABLE.BUTTONS.COPY_TO_CLIPBOARD': 'Copy to clipboard',
    'TABLE.BUTTONS.PRINT': 'Print',
    'TABLE.BUTTONS.EXPORT': 'Export',
    'TABLE.BUTTONS.EXCEL': 'Export to Excel',
    'TABLE.BUTTONS.CSV': 'Export to CSV',
    'TABLE.BUTTONS.PDF': 'Export to PDF',
    'TABLE.BUTTONS.GROUP_ROWS': 'Group rows',
    'TABLE.BUTTONS.RESIZE_COLUMNS': 'Resize columns',
    'TABLE.BUTTONS.FILTER': 'Filter',
    'TABLE.BUTTONS.REFRESH': 'Refresh',
    'TABLE.BUTTONS.DELETE': 'Delete',
    'TABLE.BUTTONS.ADD': 'New',
    'TABLE.SELECT.ROWS._': '%d rows selected',
    'TABLE.SELECT.ROWS.0': ' ',
    'TABLE.SELECT.ROWS.1': '1 row selected',
    'TABLE.SHOW_ALL': 'All',
    'TABLE.SELECT_DATE': 'Select date'
  },

  // Spanish

  'es': {
    'LANGUAGE': 'Idioma',
    'LOCALE_en': 'Inglés',
    'LOCALE_es': 'Español',
    'USERNAME': 'Usuario',
    'PASSWORD': 'Contraseña',
    'LOGIN': 'Entrar',
    'LOGOUT': 'Salir',
    'OK': 'Ok',
    'ACCEPT': 'Aceptar',
    'CANCEL': 'Cancelar',
    'YES': 'Sí',
    'NO': 'No',
    'RESET': 'Resetear',
    'CONFIRM': 'Confirmar',
    'NEXT': 'Siguiente',
    'PREVIOUS': 'Anterior',
    'FINISH': 'Finalizar',
    'SAVE': 'Guardar',
    'REFRESH': 'Refrescar',
    'SEARCH': 'Buscar',
    'FILTER': 'Filtrar',
    'DELETE': 'Borrar',
    'ADD': 'Nuevo',
    'SELECT': 'Seleccionar',
    'SELECT_ALL': 'Seleccionar todo',
    'INFO': 'Información',
    'ERROR': 'Error',
    'FOUND': 'Encontrados',
    'RESULTS': 'Resultados',
    'TOTAL': 'Total',
    'MONEY': 'Dinero',
    'HOME': 'Inicio',
    'SHOW_CONSOLE': 'Mostrar consola',
    'FILE': 'Archivo',
    'OPTIONS': 'Opciones',
    'EDIT': 'Editar',
    'UNDO': 'Deshacer',
    'REDO': 'Rehacer',
    'COPY': 'Copiar',
    'PASTE': 'Pegar',
    'LOCK': 'Bloquear',
    'EXIT': 'Salir',
    'SETTINGS': 'Configuración',
    'FEATURES': 'Características',
    'FORM': 'Formulario',
    'LIST': 'Lista',
    'TABLE': 'Tabla',
    'DETAIL': 'Detalle',
    'EXPORT': 'Exportar',
    'EXPORT_PDF': 'Exportar a PDF',
    'EXPORT_CSV': 'Exportar a CSV',
    'PAGE': 'Página',
    'FIRST_PAGE': 'Primera',
    'LAST_PAGE': 'Última',
    'PREVIOUS_PAGE': 'Anterior',
    'NEXT_PAGE': 'Siguiente',
    'PHOTO': 'Fotografía',
    'CHOOSE_FILE': 'Escoger fichero',

    'FORM_VALIDATION.REQUIRED': 'Requerido',
    'FORM_VALIDATION.LENGTH': 'Longitud no válida',
    'FORM_VALIDATION.MIN_LENGTH': 'Longitud mínima',
    'FORM_VALIDATION.MAX_LENGTH': 'Longitud máxima',
    'FORM_VALIDATION.FORMAT': 'Formato no válido',
    'FORM_VALIDATION.EMAIL_FORMAT': 'Email no válido',
    'FORM_VALIDATION.NIF_FORMAT': 'Formato no válido (DNI: 12345678-A, NIE: X-1234567-A)',
    'FORM_VALIDATION.DNI_LETTER': 'Letra de DNI no válida',
    'FORM_VALIDATION.DATE_RANGE': 'Fecha fuera del rango válido',
    'FORM_VALIDATION.MIN_VALUE': 'Valor mínimo',
    'FORM_VALIDATION.MAX_VALUE': 'Valor máximo',

    'FORM_VALIDATION.DATE_PARSE':'Formato no válido',
    'FORM_VALIDATION.DATE_FILTER':'Fecha no es válida para el filtro definido',
    'FORM_VALIDATION.DATE_MIN':'Fecha mínima',
    'FORM_VALIDATION.DATE_MAX':'Fecha máxima',

    'MESSAGES.FORM_VALIDATION_ERROR': 'El formulario contiene campos con valores no válidos',
    'MESSAGES.FORM_NOTHING_TO_UPDATE_INFO': '¡No existen valores para actualizar!',
    'MESSAGES.ERROR_LOGIN': 'Error de inicio de sesión. Compruebe nombre de usuario y/o contraseña.',
    'MESSAGES.ERROR_SESSION': 'La sesión ha caducado',
    'MESSAGES.ERROR_INSERT': 'Error al insertar datos.',
    'MESSAGES.ERROR_QUERY': 'Error al consultar datos del servidor.',
    'MESSAGES.ERROR_UPDATE': 'Error al actualizar datos.',
    'MESSAGES.ERROR_DELETE': 'Error al borrar datos.',
    'MESSAGES.ERROR_ATTRIBUTE_REQUIRED': 'Atributo requerido no proporcionado.',
    'MESSAGES.ERROR_FILE_LOAD': 'Error al cargar el archivo.',
    'MESSAGES.CONFIRM_LOGOUT': '¿Está seguro de que quiere salir?',
    'MESSAGES.CONFIRM_DELETE': '¿Está seguro de que quiere borrar los items seleccionados?',
    'MESSAGES.CONFIRM_CANCEL': '¿Está seguro de que quiere cancelar sin guardar los cambios?',
    'MESSAGES.SAVING': 'Guardando, espere...',
    'MESSAGES.SAVED': 'Guardado',
    'MESSAGES.NO_RESULTS': 'No se obtuvieron resultados.',
    'MESSAGES.ERROR_MISSING_LANG': 'No se ha encontrado el fichero de configuración del idioma seleccionado',

    'TABLE.EMPTY': 'No se han obtenido resultados',
    'TABLE.INFO': '_START_ - _END_ de _TOTAL_',
    'TABLE.INFO_EMPTY': '0 - 0 de 0',
    'TABLE.INFO_FILTERED': '(filtrados de un total de _MAX_ registros)',
    'TABLE.INFO_POST_FIX': ' ',
    'TABLE.LENGTH_MENU': 'Registros por página: _MENU_',
    'TABLE.LOADING_RECORDS': 'Cargando...',
    'TABLE.PROCESSING': 'Procesando...',
    'TABLE.SEARCH': ' ',
    'TABLE.ZERO_RECORDS': 'No se encontraron coincidencias',
    'TABLE.PAGINATE.FIRST': 'Primero',
    'TABLE.PAGINATE.LAST': 'Último',
    'TABLE.PAGINATE.NEXT': 'Siguiente',
    'TABLE.PAGINATE.PREVIOUS': 'Anterior',
    'TABLE.ARIA.SORT_ASCENDING': ': activar para ordenar la columna de forma ascendente',
    'TABLE.ARIA.SORT_DESCENDING': ': activar para ordenar la columna de forma descendente',
    'TABLE.BUTTONS.COLVIS': 'Mostrar / ocultar columnas',
    'TABLE.BUTTONS.COPY_TITLE': 'Copiado al portapapeles',
    'TABLE.BUTTONS.COPY_SUCCESS._': '%d registros copiados',
    'TABLE.BUTTONS.COPY_SUCCESS.1': '1 registro copiado',
    'TABLE.BUTTONS.COPY_TO_CLIPBOARD': 'Copiar al portapapeles',
    'TABLE.BUTTONS.PRINT': 'Imprimir',
    'TABLE.BUTTONS.EXPORT': 'Exportar',
    'TABLE.BUTTONS.EXCEL': 'Exportar a Excel',
    'TABLE.BUTTONS.CSV': 'Exportar a CSV',
    'TABLE.BUTTONS.PDF': 'Exportar a PDF',
    'TABLE.BUTTONS.GROUP_ROWS': 'Agrupar registros',
    'TABLE.BUTTONS.RESIZE_COLUMNS': 'Cambiar tamaño de columnas',
    'TABLE.BUTTONS.FILTER': 'Filtrar',
    'TABLE.BUTTONS.REFRESH': 'Refrescar',
    'TABLE.BUTTONS.DELETE': 'Eliminar',
    'TABLE.BUTTONS.ADD': 'Nuevo',
    'TABLE.SELECT.ROWS._': '%d registros seleccionados',
    'TABLE.SELECT.ROWS.0': ' ',
    'TABLE.SELECT.ROWS.1': '1 registro seleccionado',
    'TABLE.SHOW_ALL': 'Todo',
    'TABLE.SELECT_DATE': 'Seleccionar fecha'

  }

};
